module.exports = __webpack_public_path__ + "static/media/GreeceBlocks_2_2_drag_2.53730bc8.png";